import { render, staticRenderFns } from "./homepage.vue?vue&type=template&id=b7cf5276&"
import script from "./homepage.vue?vue&type=script&lang=js&"
export * from "./homepage.vue?vue&type=script&lang=js&"
import style0 from "./homepage.vue?vue&type=style&index=0&id=b7cf5276&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7cf5276')) {
      api.createRecord('b7cf5276', component.options)
    } else {
      api.reload('b7cf5276', component.options)
    }
    module.hot.accept("./homepage.vue?vue&type=template&id=b7cf5276&", function () {
      api.rerender('b7cf5276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homepage/homepage.vue"
export default component.exports